import formsReducer, {
  disableForm,
  enableForm,
  clearForm,
  setFormErrors
} from "../lib/formsReducer";
import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import * as mediaCategoriesActions from "../mediaCategories/actions";
import { Record, Map } from "immutable";
import { isApiCall } from "../app/schema";

import Forms from "./forms";
import MediaCategories from "./mediaCategories";

const feature = "mediaCategories";

const InitialState = Record({
  forms: new Forms(),
  mediaCategories: new MediaCategories()
});

const START = "_START";
const SUCCESS = "_SUCCESS";
const ERROR = "_ERROR";

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function MediaCategoriesReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload &&
      action.payload.entities &&
      action.payload.entities.mediaCategories
    ) {
      state = state.updateIn(["mediaCategories", "entities"], map =>
        map.mergeDeep(action.payload.entities.mediaCategories)
      );
    }
  }

  switch (action.type) {
    case actions.GET_MEDIA_CATEGORIES + START: {
      return state.setIn(["mediaCategories", "loading"], true);
    }
    case actions.GET_MEDIA_CATEGORIES + SUCCESS: {
      state = state.deleteIn(["mediaCategories", "entities"]);
      state = state.deleteIn(["mediaCategories", "results"]);
      state = state.setIn(
        ["mediaCategories", "meta", "all"],
        action.payload.result.meta.all
      );
      state = state.setIn(
        ["mediaCategories", "meta", "count"],
        action.payload.result.meta.count
      );
      state = state.updateIn(["mediaCategories", "entities"], map =>
        map.mergeDeep(action.payload.entities.mediaCategories)
      );
      state = state.setIn(
        ["mediaCategories", "results"],
        action.payload.result.mediaCategories
      );
      return state.setIn(["mediaCategories", "loading"], false);
    }
    case actions.GET_MEDIA_CATEGORIES + ERROR: {
      return state.setIn(["mediaCategories", "loading"], false);
    }

    case actions.GET_MEDIA_CATEGORY + START: {
      return state.setIn(["mediaCategories", "loading"], true);
    }
    case actions.GET_MEDIA_CATEGORY + SUCCESS: {
      return state.setIn(["mediaCategories", "loading"], false);
    }
    case actions.GET_MEDIA_CATEGORY + ERROR: {
      return state.setIn(["mediaCategories", "loading"], false);
    }

    case actions.POST_MEDIA_CATEGORIES: {
      return disableForm(state, "createMediaCategory");
    }
    case actions.POST_MEDIA_CATEGORIES + SUCCESS: {
      state = clearForm(state, "createMediaCategory", Forms);
      return enableForm(state, "createMediaCategory");
    }
    case actions.POST_MEDIA_CATEGORIES + ERROR: {
      state = enableForm(state, "createMediaCategory");
      return setFormErrors(state, "createMediaCategory", action.payload.errors);
    }

    case actions.PATCH_MEDIA_CATEGORIES + START: {
      return state.setIn(["mediaCategories", "loading"], true);
    }
    case actions.PATCH_MEDIA_CATEGORIES + SUCCESS: {
      return state.setIn(["mediaCategories", "loading"], false);
    }
    case actions.PATCH_MEDIA_CATEGORIES + ERROR: {
      return state.setIn(["mediaCategories", "loading"], false);
    }

    case actions.DELETE_MEDIA_CATEGORY + START: {
      return state.deleteIn([
        "mediaCategories",
        "entities",
        action.payload.uid
      ]);
    }

    case actions.GET_MEDIA_CATEGORY_MEDIAS + START: {
      return state.setIn(["mediaCategories", "loading"], true);
    }
    case actions.GET_MEDIA_CATEGORY_MEDIAS + SUCCESS: {
      state = state.setIn(
        ["mediaCategories", "entities", action.meta.uid, "medias"],
        action.payload.result.medias
      );
      return state.setIn(["mediaCategories", "loading"], false);
    }
    case actions.GET_MEDIA_CATEGORY_MEDIAS + ERROR: {
      return state.setIn(["mediaCategories", "loading"], false);
    }

    case mediaCategoriesActions.POST_MEDIA_CATEGORY_MEDIAS + START: {
      return disableForm(state, "createMediaCategoryMedia");
    }
    case mediaCategoriesActions.POST_MEDIA_CATEGORY_MEDIAS + SUCCESS: {
      state = clearForm(state, "createMediaCategoryMedia", Forms);
      return enableForm(state, "createMediaCategoryMedia");
    }
    case mediaCategoriesActions.POST_MEDIA_CATEGORY_MEDIAS + ERROR: {
      state = enableForm(state, "createMediaCategoryMedia");
      return setFormErrors(
        state,
        "createMediaCategoryMedia",
        action.payload.errors
      );
    }

    case actions.SET_IS_ADD_MEDIA_CATEGORY_MODAL_VISIBLE: {
      return state.setIn(
        ["forms", "createMediaCategory", "isAddModalVisible"],
        action.data.isVisble
      );
    }
    case actions.SET_IS_REMOVE_MEDIA_CATEGORY_MODAL_VISIBLE: {
      return state.setIn(
        ["mediaCategories", "isRemoveModalVisible"],
        action.data.isVisble
      );
    }
    case actions.SET_IS_EDIT_MEDIA_CATEGORY_MODAL_VISIBLE: {
      return state.setIn(
        ["mediaCategories", "isEditModalVisible"],
        action.data.isVisble
      );
    }
  }

  return entitiesReducer(
    formsReducer(state, feature, action, Forms),
    feature,
    action
  );
}



// WEBPACK FOOTER //
// ./src/common/mediaCategories/reducer.js